import BookmarkTableContainer from './BookmarkTableContainer.js';

export default BookmarkTableContainer;